import App from "App";
import LogInView from "components/views/LogIn";

const LogIn = (props) => (
  <App>
    <LogInView {...props} />
  </App>
);

export default LogIn;
